class BedTypes {
    static Invalid = 0;
    static Bed = 1;
    static Donut = 2;

    static getArrayValidItems() {
       return [
          { title: "None", value: this.Invalid },
          { title: "Bed with Auto-Fade", value: this.Bed },
          { title: "Bed No Fade (Donut)", value: this.Donut }
       ];
    }
}

export default BedTypes;